import { GridColumn, GridRow } from 'app/layouts/grid';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setPageTitle } from 'store/actions/header';
import { Billinginformation } from './info/display';
import { PaymentMethod } from './payment-method/payment-method.js';
import { Spacer } from 'app/layouts/generic';
import { InvoiceList } from './invoice/invoice';
import useScreenSize from 'hooks/size';
import { PlanDetails } from './plan/details';
import { WalletDetails } from './wallet';
import { useTenant } from 'contexts/tenant';

export const Billing = () => {
  const dispatch = useDispatch();
  const { isMiniDesktop } = useScreenSize();
  const { is_agency_managed } = useTenant();
  useEffect(() => {
    dispatch(
      setPageTitle([
        { title: 'Settings', path: '/billing' },
        { title: 'Billing', path: '/settings/billing' }
      ])
    );
  }, []);

  return (
    <GridRow
      num_of_columns={isMiniDesktop ? 3 : 4}
      tabletStyles={{ gridTemplateColumns: 'repeat(1,1fr)', gap: 0 }}
      mobileStyles={{ gap: 0 }}
    >
      <GridColumn>
        <PlanDetails />
        <Spacer multiple={3} />
        <WalletDetails />
        <Spacer multiple={3} />
        <PaymentMethod />
      </GridColumn>
      <GridColumn span={2}>
        <Billinginformation />
        {!is_agency_managed && (
          <>
            <Spacer multiple={3} />
            <InvoiceList />
          </>
        )}
      </GridColumn>
    </GridRow>
  );
};
